import type { i18n as I18nInstance } from "i18next";
import { SupportedLanguages } from "@/enums/internationalization";
import type { LocaleResources } from "@/i18n/namespaces";

/**
 * Register server-pushed locale JSON on an i18n instance before the first
 * translate call. Idempotent per language/namespace. Prefer passing resources
 * into `createAppI18nInstance` / `getAppI18nInitOptions` for new trees.
 */
export function applyLocaleResources(
  i18n: I18nInstance,
  language: string,
  resources: LocaleResources | null | undefined
): void {
  if (!resources || !language || language === SupportedLanguages.English) {
    return;
  }

  for (const [ns, bundle] of Object.entries(resources)) {
    if (!bundle) continue;
    if (i18n.hasResourceBundle(language, ns)) continue;
    i18n.addResourceBundle(language, ns, bundle, true, true);
  }
}
